import styled from '@emotion/styled';
import { colors, typography } from 'component-library';

export const LocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PartnerDescription = styled.span<{ normal?: boolean }>`
  ${({ normal }) => (normal ? typography.body.large : typography.body.medium)};
  ${({ normal }) => (normal ? `color: ${colors.base.black};` : `color: ${colors.primary.grey};`)};

  display: block;
`;
